import React from "react";
import PropTypes from "prop-types";
import { useFormContext, useWatch } from "react-hook-form";
import EditorFormSection from "../../EditorFormSection";
import FormattedNumber from "../../FormattedNumber";
import { useSelector } from "react-redux";

const SummarySection = ({ isOpen, togglePanel, sections }, context) => {
  const { control } = useFormContext();

  const { language } = useSelector((state) => ({
    size: state.editorSize,
  }));

  const width = useWatch({ control, name: "width" });
  const height = useWatch({ control, name: "height" });
  const editorType = useWatch({ control, name: "editorType" });
  const laminate = useWatch({ control, name: "laminate" });
  const filecheck = useWatch({ control, name: "filecheck" });
  const cutting = useWatch({ control, name: "cutting" });
  const whiteprint_mode = useWatch({ control, name: "whiteprint_mode" });
  const underglass = useWatch({ control, name: "underglass" });
  const border = useWatch({ control, name: "border" });
  const artworkId = useWatch({ control, name: "artworkId" });
  const selectedMaterial = useWatch({ control, name: "materialSerie" });
  const fileJson = useWatch({ control, name: "fileJson" });

  return (
    <EditorFormSection
      help={context.t("FileEditor.summary.help")}
      panelName="summary"
      panelTitle={context.t("summary")}
      open={isOpen}
      toggle={togglePanel}
    >
      <div className="editorform-resume">
        <div>
          <span>{context.t("Type")}:&nbsp;</span>
          {editorType}
        </div>

        <div>
          <span>{context.t("Artwork Id")}:&nbsp;</span>
          {artworkId}
        </div>

        <div>
          <span>{context.t("Width")}:&nbsp;</span>
          <FormattedNumber
            value={Math.round(width * 100) / 100}
            language={language}
            unit="mm"
            decimals={1}
          />
          &nbsp;=&nbsp;
          <FormattedNumber
            value={Math.round(width * 10) / 100}
            language={language}
            unit="cm"
            decimals={2}
          />
        </div>

        <div>
          <span>{context.t("Height")}:&nbsp;</span>
          <FormattedNumber
            value={Math.round(height * 100) / 100}
            language={language}
            unit="mm"
            decimals={1}
          />
          &nbsp;=&nbsp;
          <FormattedNumber
            value={Math.round(height * 10) / 100}
            language={language}
            unit="cm"
            decimals={2}
          />
        </div>

        {sections?.includes("vinyl") && (
          <div>
            <span>{context.t("Material Serie")}:&nbsp;</span>
            {context.t(`${selectedMaterial}`)}
          </div>
        )}

        {sections?.includes("color") && (
          <div>
            <span>{context.t("Color")}:&nbsp;</span>
            {fileJson?.color?.title}
          </div>
        )}

        {sections?.includes("laminate") && (
          <div>
            <span>{context.t("Laminate")}:&nbsp;</span>
            {context.t(`${laminate}`)}
          </div>
        )}

        {sections?.includes("whiteprint_mode") && (
          <div>
            <span>{context.t("Whiteprint")}:&nbsp;</span>
            {context.t(`${whiteprint_mode}`)}
          </div>
        )}

        {sections?.includes("cutting") && (
          <div>
            <span>{context.t("Cutting")}:&nbsp;</span>
            {context.t(`${cutting}`)}
          </div>
        )}

        {sections?.includes("border") && (
          <div>
            <span>{context.t("Border")}:&nbsp;</span>
            {context.t(`${border}`)}
          </div>
        )}

        {sections?.includes("filecheck") && (
          <div>
            <span>{context.t("FileCheck")}:&nbsp;</span>
            {context.t(`${filecheck}`)}
          </div>
        )}

        {sections?.includes("underglass") && (
          <div>
            <span>{context.t("Underglass")}:&nbsp;</span>
            {underglass ? context.t("Yes") : context.t("No")}
          </div>
        )}
      </div>
    </EditorFormSection>
  );
};

SummarySection.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  togglePanel: PropTypes.func.isRequired,
  sections: PropTypes.arrayOf(PropTypes.string).isRequired,
};

SummarySection.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default SummarySection;
